/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseInputWrapper.vue?vue&type=template&id=e9dbcad6"
import script from "./BaseInputWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseInputWrapper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseInputWrapper.vue?vue&type=style&index=0&id=e9dbcad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports